// Use environment variable for API URL, fallback to local development URL
const API_URL = process.env.NODE_ENV === 'development' 
  ? 'http://localhost:10000/api/v1'
  : '/api/v1';

export { API_URL }; 